import {LeadEventApiDto, LeadFilesDeletedEventDataApiDto} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import TextUtils from "../../../utils/TextUtils";
import moment = require("moment");

export default class LeadFilesDeletedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data lead files removed files event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadFilesDeletedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadFilesDeletedEvent {
		const data = LeadFilesDeletedEventData.fromJson(json.data as LeadFilesDeletedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadFilesDeletedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.LeadFilesDeleted,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.deletedFiles;
	}

	getActivityMessage(): string {
		return `${TextUtils.addSIfPlural("File", this.data.deletedFiles.length)} removed`;
	}
}

export class LeadFilesDeletedEventData {
	constructor(public readonly deletedFiles: Attachment[]) {}

	public static fromJson(json: LeadFilesDeletedEventDataApiDto): LeadFilesDeletedEventData {
		return new LeadFilesDeletedEventData(json.deletedFiles.map(Attachment.fromJson));
	}
}
